const COLORS = require("../enums/colors.json");
const JOBS = require("../enums/jobs.json");
const PROJECTS = require("../enums/projects.json");
const PATHS = require("../enums/paths.json");
module.exports = {
  COLORS,
  JOBS,
  PROJECTS,
  PATHS,
};

// 8 characters
// 12 characters
// 11 characters
